// File: frontend/src/pages/Plato/config/platoConfig.js

import { platoConfigJson } from './platoConfigJson';

// Export the original JSON config for backward compatibility
export const platoConfig = platoConfigJson;

// Templates with exact names and IDs from your backend
export const templates = [
  {
    id: '2c806623-dc74-4f8b-961b-c7dd82529dd4',
    name: 'Technical Analysis Template',
    description: 'Designed for detailed technical analysis with formal tone and analytical approach',
    icon: 'BarChart'
  },
  {
    id: '2269703c-96ac-4797-a549-98c794ae5507',
    name: 'Narrative Engagement Template',
    description: 'Optimized for engaging storytelling with friendly tone and narrative style',
    icon: 'BookOpen'
  },
  {
    id: 'f00167a5-12f4-4d8c-afc2-e51790b98f61',
    name: 'Executive Brief Template',
    description: 'Structured for executive-level communication with assertive tone and persuasive style',
    icon: 'FileText'
  }
];

// Domains based on your actual agent list
export const domains = [
  {
    id: 'plato_general',
    key: 'ai_plato_general',
    name: 'General Knowledge',
    description: 'Cross-domain knowledge transfer and amplification for general insurance concepts',
    icon: 'Globe'
  },
  {
    id: 'plato_property_casualty',
    key: 'ai_plato_property_and_casualty',
    name: 'Property & Casualty',
    description: 'Specialized knowledge in P&C insurance including auto, home, commercial, and liability',
    icon: 'Shield'
  },
  {
    id: 'plato_life',
    key: 'ai_plato_life',
    name: 'Life Insurance',
    description: 'Knowledge transfer for life insurance products, underwriting, and risk assessment',
    icon: 'Heart'
  },
  {
    id: 'plato_health',
    key: 'ai_plato_health',
    name: 'Health Insurance',
    description: 'Health insurance domain knowledge including medical, clinical, and administrative aspects',
    icon: 'Activity'
  },
  {
    id: 'plato_pension',
    key: 'ai_plato_pension',
    name: 'Pension',
    description: 'Pension and retirement planning knowledge including regulations and investment strategies',
    icon: 'TrendingUp'
  },
  {
    id: 'plato_reinsurance',
    key: 'ai_plato_reinsurance',
    name: 'Reinsurance',
    description: 'Specialized knowledge in reinsurance concepts, treaties, and risk transfer mechanisms',
    icon: 'Layers'
  }
];

// Capability matrix data
export const capabilities = {
  versions: ['AI-1 (2024-Q4)', 'AI-2 (2025-Q3)', 'AI-3 (2025-Q3)', 'AI-4 (2026-Q3)'],
  categories: [
    {
      name: 'Plato',
      description: 'A sophisticated platform for transferring, refining, and amplifying knowledge across various domains and disciplines',
      capabilities: [
        {
          name: 'P&C, Health, Life, Pension, Reinsurance',
          versions: {
            'AI-1 (2024-Q4)': true,
            'AI-2 (2025-Q3)': true,
            'AI-3 (2025-Q3)': true,
            'AI-4 (2026-Q3)': true
          }
        }
      ]
    },
    {
      name: 'Knowledge Processing',
      description: 'Core capabilities for processing and transforming knowledge',
      capabilities: [
        {
          name: 'Domain-specific knowledge extraction',
          versions: {
            'AI-1 (2024-Q4)': true,
            'AI-2 (2025-Q3)': true,
            'AI-3 (2025-Q3)': true,
            'AI-4 (2026-Q3)': true
          }
        },
        {
          name: 'Cross-domain knowledge synthesis',
          versions: {
            'AI-1 (2024-Q4)': false,
            'AI-2 (2025-Q3)': true,
            'AI-3 (2025-Q3)': true,
            'AI-4 (2026-Q3)': true
          }
        },
        {
          name: 'Automated knowledge validation',
          versions: {
            'AI-1 (2024-Q4)': false,
            'AI-2 (2025-Q3)': false,
            'AI-3 (2025-Q3)': true,
            'AI-4 (2026-Q3)': true
          }
        }
      ]
    },
    {
      name: 'Integration',
      description: 'Integration capabilities with external systems and data sources',
      capabilities: [
        {
          name: 'API-based knowledge exchange',
          versions: {
            'AI-1 (2024-Q4)': true,
            'AI-2 (2025-Q3)': true,
            'AI-3 (2025-Q3)': true,
            'AI-4 (2026-Q3)': true
          }
        },
        {
          name: 'Real-time knowledge streaming',
          versions: {
            'AI-1 (2024-Q4)': false,
            'AI-2 (2025-Q3)': true,
            'AI-3 (2025-Q3)': true,
            'AI-4 (2026-Q3)': true
          }
        },
        {
          name: 'Enterprise system integration',
          versions: {
            'AI-1 (2024-Q4)': false,
            'AI-2 (2025-Q3)': false,
            'AI-3 (2025-Q3)': true,
            'AI-4 (2026-Q3)': true
          }
        }
      ]
    }
  ]
};

export default {
  templates,
  domains,
  capabilities,
  parameters: platoConfig.parameters
};